/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconExclamationCircle = createReactComponent(
  "exclamation-circle",
  "IconExclamationCircle",
  [
    ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
    ["path", { d: "M12 9v4", key: "svg-1" }],
    ["path", { d: "M12 16v.01", key: "svg-2" }]
  ]
);

export { IconExclamationCircle as default };
//# sourceMappingURL=IconExclamationCircle.js.map
